// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"EmailTemplatesForm__wrapper__swHoe","submitResult":"EmailTemplatesForm__submitResult__2_zzG","actionWrapper":"EmailTemplatesForm__actionWrapper__1YjBB","wrapper2faOptions":"EmailTemplatesForm__wrapper2faOptions__1Oy6z"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/EmailTemplates/EmailTemplatesForm/EmailTemplatesForm.css
// module id = 3212
// module chunks = 0